import { render, staticRenderFns } from "./NewBieprivAddPrice.vue?vue&type=template&id=6f220047&scoped=true"
import script from "./NewBieprivAddPrice.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewBieprivAddPrice.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./NewBieprivAddPrice.vue?vue&type=style&index=0&id=6f220047&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f220047",
  null
  
)

export default component.exports